"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionSetMetaData = exports.actionPlaceOrderError = exports.actionSetOrderId = exports.actionSetIsPlacingOrder = exports.actionSetCartWithError = exports.actionSetCartIsLoaded = exports.actionSetCartIsLoading = exports.actionClearCart = exports.actionSetCartStrategy = exports.actionSetCartItems = exports.actionSetCartData = exports.actionUpdateItemQuantity = exports.actionRemoveCartItem = exports.actionAddCartItem = void 0;
const types_1 = require("../types");
const actionAddCartItem = (item) => ({
    type: types_1.CartActionTypes.ADD_ITEM,
    item,
});
exports.actionAddCartItem = actionAddCartItem;
const actionRemoveCartItem = (item) => ({
    type: types_1.CartActionTypes.REMOVE_ITEM,
    item,
});
exports.actionRemoveCartItem = actionRemoveCartItem;
const actionUpdateItemQuantity = (item) => ({
    type: types_1.CartActionTypes.UPDATE_ITEM_QUANTITY,
    item,
});
exports.actionUpdateItemQuantity = actionUpdateItemQuantity;
const actionSetCartData = (item) => ({
    type: types_1.CartActionTypes.SET_CART_DATA,
    item,
});
exports.actionSetCartData = actionSetCartData;
const actionSetCartItems = (item) => ({
    type: types_1.CartActionTypes.SET_CART_ITEMS,
    item,
});
exports.actionSetCartItems = actionSetCartItems;
const actionSetCartStrategy = (item) => ({
    type: types_1.CartActionTypes.SET_STRATEGY,
    item,
});
exports.actionSetCartStrategy = actionSetCartStrategy;
const actionClearCart = () => ({
    type: types_1.CartActionTypes.CLEAR_CART,
});
exports.actionClearCart = actionClearCart;
const actionSetCartIsLoading = () => ({
    type: types_1.CartActionTypes.LOADING_CART,
});
exports.actionSetCartIsLoading = actionSetCartIsLoading;
const actionSetCartIsLoaded = () => ({
    type: types_1.CartActionTypes.LOADED_CART,
});
exports.actionSetCartIsLoaded = actionSetCartIsLoaded;
const actionSetCartWithError = () => ({
    type: types_1.CartActionTypes.ERROR,
});
exports.actionSetCartWithError = actionSetCartWithError;
const actionSetIsPlacingOrder = () => ({
    type: types_1.CartActionTypes.LOADING_CART,
});
exports.actionSetIsPlacingOrder = actionSetIsPlacingOrder;
const actionSetOrderId = (orderId) => ({
    type: types_1.CartActionTypes.SET_ORDER_ID,
    item: orderId,
});
exports.actionSetOrderId = actionSetOrderId;
const actionPlaceOrderError = () => ({
    type: types_1.CartActionTypes.ERROR,
});
exports.actionPlaceOrderError = actionPlaceOrderError;
const actionSetMetaData = (item) => ({
    type: types_1.CartActionTypes.SET_META_DATA,
    item,
});
exports.actionSetMetaData = actionSetMetaData;
